import React from 'react'
import { 
  CasesTableContainer,
  LoadingTableContainer,
  TableContentWrapper,
  EmptyState
} from './styles'
import CaseComponent from '../Case'
import CaseErrorBoundary from './CaseErrorBoundary'
import { useOneClickPrescribeContext } from '../../context/OneClickPrescribeContext'

import { VeritasSpinner } from '../../../../components/VeritasSpinner'

import { CaseTagEnum, RequestTypeEnum } from '../../../../types/enums'

import { SectionHeader } from './styles'

const CasesTable = () => {
  const {
    displayedCases,
    showFlaggedCases,
    getCaseAnimationState,
    loading,
  } = useOneClickPrescribeContext()
  
  if (loading) {
    return (
      <CasesTableContainer>
        <LoadingTableContainer>
          <VeritasSpinner size="large" tip="Loading cases..." />
        </LoadingTableContainer>
      </CasesTableContainer>
    )
  }

  const casesByStatus = displayedCases.reduce((acc, _case) => {
    const caseId = _case.caseId || _case._id
    const { isSuccessCollapsed } = getCaseAnimationState(caseId)
    const tags = new Set(_case.tags || [])
    
    if (tags.has('acknowledged')) {
      return acc
    }
    
    const isCleared = tags.has(CaseTagEnum.CLEAN_MIF)
 
    const list = isCleared ? 'cleared' : 'flagged'
    acc[list].push(_case)
    return acc
  }, { flagged: [], cleared: [] })

  const activeCases = casesByStatus[showFlaggedCases ? 'flagged' : 'cleared']

  const newCases = activeCases.filter(c => c.requestType !== RequestTypeEnum.RX_RENEWAL)
  const renewalCases = activeCases.filter(c => c.requestType === RequestTypeEnum.RX_RENEWAL)

  const renderCase = (caseData) => {
    const caseId = caseData.caseId || caseData._id
    const { isFadingOut, isCollapsing, isSuccessCollapsed, autoDismissProgress } = getCaseAnimationState(caseId)

    return (
      <CaseErrorBoundary key={caseId}>
        <CaseComponent 
          flagged={showFlaggedCases}
          caseData={caseData}
          isFadingOut={isFadingOut}
          isCollapsing={isCollapsing}
          isSuccessCollapsed={isSuccessCollapsed}
          autoDismissProgress={autoDismissProgress}
          isFlagged={showFlaggedCases}
        />
      </CaseErrorBoundary>
    )
  }

  return (
    <CasesTableContainer>
      <TableContentWrapper>
        {displayedCases?.length > 0 ? (
          <>
            {newCases.length > 0 && (
              <>
                <SectionHeader>New Cases ({newCases.length})</SectionHeader>
                {newCases.map(renderCase)}
              </>
            )}
            {renewalCases.length > 0 && (
              <>
                <SectionHeader $isRenewal>Renewals ({renewalCases.length})</SectionHeader>
                {renewalCases.map(renderCase)}
              </>
            )}
          </>
        ) : (
          <EmptyState 
            description="No cases available"
          />
        )}
      </TableContentWrapper>
    </CasesTableContainer>
  )
}

export default CasesTable
